
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Search } from 'lucide-react';
import { siteConfig } from '../config/site';
import { useLanguage } from '../App';

interface HeaderProps {
  onOpenMenu: () => void;
}

const Header: React.FC<HeaderProps> = ({ onOpenMenu }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t, openBooking } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 w-full z-40 transition-all duration-700 ${isScrolled ? 'bg-black/95 backdrop-blur-xl py-3 border-b border-accent/10 shadow-2xl' : 'bg-transparent py-6 sm:py-8'}`}>
      <div className="max-w-7xl mx-auto px-6 sm:px-12 flex items-center justify-between">
        <button 
          onClick={onOpenMenu}
          className="flex items-center gap-3 group text-accent hover:text-white transition-colors uppercase tracking-[0.3em] text-[10px] font-black"
          aria-label="Open Menu"
        >
          <Menu className="w-5 h-5 transition-transform group-hover:scale-110" />
          <span className="hidden md:inline">{t.menu}</span>
        </button>

        <Link to="/" className="flex flex-col items-center group">
          <div className="relative mb-2">
            <img src={siteConfig.images.logo} alt="Santi Bladez Logo" className="w-10 h-10 sm:w-12 sm:h-12 object-contain filter drop-shadow-[0_0_12px_rgba(205,127,50,0.3)] group-hover:scale-105 transition-transform duration-700 rounded-full border border-accent/20" />
          </div>
          <h1 className="text-[10px] sm:text-xs font-serif font-bold tracking-[0.4em] text-white/60 group-hover:text-accent transition-colors uppercase">
            {siteConfig.brandName}
          </h1>
        </Link>

        <div className="flex items-center gap-4 sm:gap-8">
          <button 
            onClick={openBooking}
            className="hidden sm:block px-8 py-2.5 border border-accent/30 text-accent hover:bg-accent hover:text-black transition-all duration-500 text-[10px] tracking-[0.2em] font-black uppercase"
          >
            {t.bookConcierge}
          </button>
          <button className="text-accent/60 hover:text-accent transition-colors" aria-label="Search">
            <Search className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
